import $ from 'jquery';

$('.js-quantity').each((index, quantity) => {
  const $quantity = $(quantity);
  const $quantityIncrement = $quantity.find('.js-quantity-increment');
  const $quantityDecrement = $quantity.find('.js-quantity-decrement');
  const $quantityControl = $quantity.find('.js-quantity-control');

  $quantityIncrement.on('click', () => {
    $quantityControl.val(Number($quantityControl.val()) + 1).trigger('change');
  });

  $quantityDecrement.on('click', () => {
    $quantityControl.val(Number($quantityControl.val()) - 1).trigger('change');
  });

  function clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
  }

  function update() {
    const value = Number($quantityControl.val());
    const min = Number($quantityControl.attr('min'));
    const max = Number($quantityControl.attr('max'));
    $quantityIncrement.attr('disabled', value >= max);
    $quantityDecrement.attr('disabled', value <= min);
    if (value < min || value > max) {
      $quantityControl.val(clamp(value, min, max)).trigger('change');
    }
    if (value % 1 !== 0) {
      $quantityControl.val(Math.round(value)).trigger('change');
    }
  }

  $quantityControl.on('change', update);

  update();
});
